import { esc, q } from '../../shared/dom';
import { t } from '../../shared/i18n';
import { ApiError } from '../../shared/api/http';
import { authApi } from './auth.api';
import { authRoutes } from './auth-routes';
import { bindPasswordToggles, passwordField } from './password-field';

const MIN_LENGTH = 8;

/** Nova senha a partir do link do e-mail (`#/reset/<token>`). */
export function renderResetPasswordScreen(root: HTMLElement, token: string): void {
  root.innerHTML = `
    <h2 class="auth-title" data-i18n="auth.resetTitle">${esc(t('auth.resetTitle'))}</h2>
    <p class="auth-lead" data-i18n="auth.resetLead">${esc(t('auth.resetLead'))}</p>
    <form class="auth-form" id="reset-form" novalidate>
      ${passwordField('reset-password', 'auth.newPassword', { autocomplete: 'new-password' })}
      ${passwordField('reset-confirm', 'auth.confirmPassword', { autocomplete: 'new-password' })}
      <div class="auth-hint" data-i18n="auth.passwordRule">${esc(t('auth.passwordRule'))}</div>
      <div class="auth-error" id="reset-error" role="alert"></div>
      <div class="auth-success" id="reset-ok" role="status"></div>
      <button type="submit" class="btn btn-primary auth-submit" id="reset-submit">${esc(t('auth.savePassword'))}</button>
      <div class="auth-links">
        <a class="auth-link" href="${authRoutes.login}" data-i18n="auth.backToLogin">${esc(t('auth.backToLogin'))}</a>
        <a class="auth-link" href="${authRoutes.forgot}" data-i18n="auth.newLink">${esc(t('auth.newLink'))}</a>
      </div>
    </form>`;

  bindPasswordToggles(root);
  const form = q<HTMLFormElement>('#reset-form', root);
  const password = q<HTMLInputElement>('#reset-password', root);
  const confirm = q<HTMLInputElement>('#reset-confirm', root);
  const error = q('#reset-error', root);
  const ok = q('#reset-ok', root);
  const submit = q<HTMLButtonElement>('#reset-submit', root);

  if (token.length !== 64) { error.textContent = t('auth.errBadLink'); submit.disabled = true; return; }
  password.focus();

  form.addEventListener('submit', async e => {
    e.preventDefault();
    error.textContent = ''; ok.textContent = '';
    if (password.value.length < MIN_LENGTH) { error.textContent = t('auth.errShort'); password.focus(); return; }
    if (password.value !== confirm.value) { error.textContent = t('auth.errMismatch'); confirm.focus(); return; }

    submit.disabled = true;
    try {
      await authApi.resetPassword(token, password.value);
      ok.textContent = t('auth.resetDone');
      form.querySelectorAll('input').forEach(i => { i.disabled = true; });
    } catch (err) {
      error.textContent = err instanceof ApiError && err.status === 400 ? t('auth.errBadLink') : t('auth.errGeneric');
      submit.disabled = false;
    }
  });
}
